import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-1x211e8-0"
})(["position:relative;width:100%;"]);